module.exports = __webpack_public_path__ + "img/lock-check-ring.71a7eb66.svg";